export const DiamondMark = ({ size = 34, className = "" }) => (
  <svg width={size} height={size * 0.72} viewBox="0 0 96 70" className={className} aria-hidden="true">
    <g fill="#2B5CB8">
      <path d="M24 6 44 24 24 42 4 24Z" />
      <path d="M70 0 92 18 70 36 48 18Z" />
      <path d="M52 34 72 52 52 70 32 52Z" />
      <path d="M88 30 96 38 80 54 72 46Z" />
    </g>
  </svg>
);

export const Logo = () => (
  <img
    src="/logo.png"
    alt="ESAIA | Ethical Standards for Artificial Intelligence Assurance"
    className="h-10 w-auto"
    data-testid="navbar-brand-logo"
  />
);
